import React from 'react';
export function SocialProof() {
  return <section className="w-full bg-ink-900 pb-12" aria-labelledby="prueba-social" style={{
    paddingTop: "0px",
    paddingBottom: "0px"
  }} data-id="element-165" data-mp="17pxvk450lqh8">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-166" data-mp="36vttlgi8quxx">
        <div className="grid gap-6 rounded-2xl border border-ink-800 bg-ink-950 p-8 sm:grid-cols-[auto_1fr] sm:items-center sm:gap-10" style={{
        paddingTop: "13px",
        paddingBottom: "13px"
      }} data-id="element-167" data-mp="36xeq3bo48nyf">
          <p className="font-display text-5xl font-900 leading-none text-gold" style={{
          fontSize: "32px"
        }} data-id="element-168" data-mp="3h7k2yi8aemh">+1.200</p>
          <div data-id="element-169" data-mp="3puzaa5fxqycp">
            <p id="prueba-social" className="text-[17px] leading-relaxed text-slate-200" data-id="element-170" data-mp="3pteksu8ha5lp">
              familias en España y Latinoamérica ya tomaron el control de su energía con este
              sistema. Familias corrientes, sin conocimientos técnicos, que hoy producen su propia
              electricidad, cobran por su excedente y miran su factura con una sonrisa.
            </p>
            
          </div>
        </div>
      </div>
    </section>;
}